import React, { useState } from 'react'
import Reviews from '@components/pages/components/Reviews'
import TrustpilotReviewsDrawer from '@components/product/TrustpilotReviewsDrawer'
import {
  formatDate,
  TrustpilotRatings,
  TrustpilotReview
} from '@api/trustpilot'
import styles from './styles.module.scss'

type Props = {
  ratings: TrustpilotRatings
  reviews: TrustpilotReview[]
  drawerReviews?: TrustpilotReview[]
  productType: string
}

export default function TrustpilotReviews({
  ratings,
  reviews,
  drawerReviews,
  productType
}: Props) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  if (ratings.numberOfReviews.total === 0 || reviews.length === 0) return null

  const reviewsMap = Object.fromEntries(
    reviews.map((review, i) => [
      i,
      {
        stars: review.stars,
        description: review.content,
        author: review.consumer.displayName,
        date: formatDate(review.createdAt)
      }
    ])
  )

  const title = (
    <>
      <span className={styles.TrustpilotReviews__score}>
        {ratings.starsAverage.toFixed(1)}
      </span>
      <span className={styles.TrustpilotReviews__count}>
        Based on {ratings.numberOfReviews.total} reviews
      </span>
    </>
  )

  const drawerAvailable = !!drawerReviews?.length

  return (
    <>
      <Reviews
        title={title}
        reviews={reviewsMap}
        onReadMore={drawerAvailable ? () => setDrawerOpen(true) : undefined}
      />
      {drawerAvailable && (
        <TrustpilotReviewsDrawer
          isOpen={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ratings={ratings}
          initialReviews={drawerReviews}
          productType={productType}
        />
      )}
    </>
  )
}
